import PropTypes from "prop-types";
import { NavLink as RouterLink, useLocation } from "react-router-dom";
// @mui
import { Box, Collapse, List, ListItemText } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
//
import { useContext, useState } from "react";
import { isUserSeller } from "src/constants/user_constants";
import { GlobalContext } from "src/context/GlobalState";
import { StyledNavItem, StyledNavItemIcon } from "./styles";
// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array
};

export default function NavSection({ data = [], ...other }) {
  const isSeller = isUserSeller(JSON.parse(localStorage.getItem("user")) || "{}");
  if (isSeller) {
    data = data.filter((item) => item.path !== "/dashboard/promos");
  }
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => item.show && <NavItem key={item.title} item={item} />)}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------
NavItem.propTypes = {
  item: PropTypes.object
};

function NavItem({ item }) {
  const { title, path, icon, info, badge, end = false, children } = item;
  const { dispatch } = useContext(GlobalContext);
  const { pathname } = useLocation();

  const hasChildren = Array.isArray(children) && children.length > 0;
  const isChildActive = hasChildren && children.some((child) => pathname.startsWith(child.path));
  const [open, setOpen] = useState(isChildActive);

  const clearStates = () => {
    dispatch({ type: "clear" });
  };

  if (hasChildren) {
    return (
      <>
        <StyledNavItem
          onClick={() => setOpen((prev) => !prev)}
          sx={{
            cursor: "pointer",
            ...(isChildActive && {
              color: "#EF7B22",
              fontWeight: "fontWeightBold"
            })
          }}
        >
          <StyledNavItemIcon>{icon}</StyledNavItemIcon>
          <ListItemText disableTypography primary={title} />
          {open ? (
            <KeyboardArrowUp sx={{ width: 18, height: 18 }} />
          ) : (
            <KeyboardArrowDown sx={{ width: 18, height: 18 }} />
          )}
        </StyledNavItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List disablePadding>
            {children.map(
              (child) =>
                child.show && (
                  <StyledNavItem
                    key={child.title}
                    component={RouterLink}
                    to={child.path}
                    end={child.end}
                    onClick={clearStates}
                    sx={{
                      pl: 5,
                      height: 40,
                      "&.active": {
                        color: "white",
                        bgcolor: "#EF7B22",
                        fontWeight: "fontWeightBold"
                      }
                    }}
                  >
                    <ListItemText
                      disableTypography
                      primary={<span style={{ fontSize: 13 }}>{child.title}</span>}
                    />
                  </StyledNavItem>
                )
            )}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      end={end}
      onClick={() => {
        clearStates();
      }}
      sx={{
        "&.active": {
          color: "white",
          bgcolor: "#EF7B22",
          fontWeight: "fontWeightBold"
        }
      }}
    >
      <StyledNavItemIcon>{badge ? badge(icon) : (icon ?? icon)}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
